<template>
  <div class="text-container" :class="isPc ? 'pc': 'mobile'">
    <div :class="isPc ? 'input-container pc': 'input-container mobile'">
      <el-input :disabled="isDisabled" class="input" v-model="internalValue"/>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: {
    },
    title: {
      type: String,
      default: ''
    },
    option: {
      type: Array
    },
    isPc: {
      type: Boolean,
      default: true
    },
    link: {
      type: String
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      internalValue: ''
    }
  },
  computed: {
  },
  created () {
    this.internalValue = this.value
  },
  mounted () {
  },
  methods: {
  },
  watch: {
    value: {
      handler (val, oldVal) {
        this.internalValue = val
      },
      immediate: true
    },
    internalValue (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.text-container {
  padding: 10px 0 0 0;

  &.pc {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .input-container {
    &.pc {
      width: 35%;
    }
  }
}
</style>
